// extracted by mini-css-extract-plugin
export var latestResources = "style-module--latest-resources--c2915";
export var latestResources__image = "style-module--latest-resources__image--f47cf";
export var latestResources__link = "style-module--latest-resources__link--04d3e";
export var latestResources__text = "style-module--latest-resources__text--1b2d6";